import { render, staticRenderFns } from "./ReportsDeliverySacPublicView.vue?vue&type=template&id=645aead0"
import script from "./ReportsDeliverySacPublicView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacPublicView.vue?vue&type=script&lang=ts"
import style0 from "./ReportsDeliverySacPublicView.vue?vue&type=style&index=0&id=645aead0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports